import { render, staticRenderFns } from "./QuizManage.vue?vue&type=template&id=3b283972&scoped=true"
import script from "./QuizManage.vue?vue&type=script&lang=js"
export * from "./QuizManage.vue?vue&type=script&lang=js"
import style0 from "./QuizManage.vue?vue&type=style&index=0&id=3b283972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b283972",
  null
  
)

export default component.exports